import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LegalCaseTypeActions = {
  getSelectedLegalCaseTypes: async ({ commit }, requestData) => {
    return axiosRequest.
      get('/legal_case_types', { params: requestData }).
      then(({ data }) => commit('setSelectedLegalCaseTypes', data)).
      catch(handleError)
  },
}
